import React from 'react';

const Trash = () => {
    return (
        <svg width={9} height={10} viewBox="0 0 9 10">
            <path
                d="M8.5 2h-2v-.5A1.5 1.5 0 005 0H4a1.5 1.5 0 00-1.5 1.5V2h-2a.5.5 0 100 1H1v5.5A1.5 1.5 0 002.5 10h4A1.5 1.5 0 008 8.5V3h.5a.5.5 0 100-1zm-5-.5A.5.5 0 014 1h1a.5.5 0 01.5.5V2h-2zm3.5 7a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5V3h5z"
                fill="#ff2727"
            />
        </svg>
    );
};

export default Trash;
